<template>
  <div></div>
</template>

<script>
import Qr from '@/components/overlay/Qr'
import { OAUTH_INFO_API_URL } from 'dygc'

export default {
  name: 'OverlayOnlyWeixin',
  created() {
    const h = this.$createElement
    const origin = window.location.origin
    let content = [
      h('div', { attrs: { class: 'flex items-center justify-center' } }, [
        h('img', { attrs: { src: '/assets/img/common/weixin.png', width: '16', class: 'mr-1' } }),
        h('span', { attrs: { class: 'text-medium text-theme-black-650 align-middle' } }, '用微信扫一扫下面的二维码')
      ]),
      h('div', { attrs: { class: 'text-center mt-4' } }, [
        h(Qr, {
          props: {
            url: `${origin}${OAUTH_INFO_API_URL}?returnUrl=${encodeURIComponent(`${origin}/mobile${location.search}`)}`
          }
        })
      ])
    ]
    if (this.$bus.survey.otherSetting.enableInterestingAnswer) {
      content.push(
        h(
          'div',
          {
            attrs: { class: 'text-center mt-4' },
            on: {
              click() {
                window.open(`${origin}/entrance`)
              }
            }
          },
          [h('el-button', { props: { type: 'primary' } }, '我也要免费创建活动')]
        )
      )
    }
    this.$msgbox({
      title: '您需要在微信中打开才能参与',
      message: h('div', content),
      showClose: false,
      showConfirmButton: false,
      showCancelButton: false,
      closeOnClickModal: false,
      customClass: 'only-weixin-wrapper'
    })
  }
}
</script>

<style>
.only-weixin-wrapper {
  width: 265px !important;
}
</style>
